import { ProFormUploadDragger } from '@ant-design/pro-components';
import React from 'react';
import { ProFormDirectUpload } from "./_";
export var ProFormDirectUploadDragger = function ProFormDirectUploadDragger(properties) {
  return /*#__PURE__*/React.createElement(ProFormDirectUpload, properties, ProFormUploadDragger);
};